import { render, staticRenderFns } from "./EmailGo.vue?vue&type=template&id=228f6b9b&"
import script from "./EmailGo.vue?vue&type=script&lang=js&"
export * from "./EmailGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports